
import { Swiper, Navigation } from "swiper";
import { mapActions } from 'vuex';
import { mapMutations } from 'vuex'; 
import axios from "axios";
export default {
    name: "browse-container",
    props: ["pa_page_name"],
    data() {
        return {
            swiper: '',
        }
    },
    computed: {
        browse_data() {
            return this.$store.state.browse.browse_data;
        }
    },
    methods: {
        ...mapActions('browse', [
            'getBrowseData',
        ]),
        ...mapMutations('browse', [
            'setBrowseData'
        ]),
        async clearHistoryBrowseData() {
            const API_url = "https://www.pixnet.net/mainpage/api/channel/cacheUserReadArticles"
            const params = { clear: 1 }
            const req = axios.get(API_url ,{ params: params });
            req.then((e) => {
                if(!e.data.error && e.status === 200) {
                    this.setBrowseData(e.data.data)
                }
            })
            .catch((e) => {
                console.log(e)
            })
        },
        paFunction(link, idx) {
            let reg_link = link.replace('https://','http://');
            let pa_idx = 1 + (idx + 1)/10000;
            window._piq.push(['trackEvent', `rs2022::十大頻道::${this.pa_page_name}`, 'imps::最近瀏覽::article_card::user_history', `最近瀏覽::${reg_link}`, pa_idx]);
        },
        paClickFunction(link, idx) {
            let reg_link = link.replace('https://','http://');
            let pa_idx = 1 + (idx + 1)/10000;
            window._piq.push(['trackEvent', `rs2022::十大頻道::${this.pa_page_name}`, 'click::最近瀏覽::article_card::user_history', `最近瀏覽::${reg_link}`, pa_idx]);
        },
        visibilityChanged(isVisible, entry, link, idx) {
            if (isVisible) {
                this.paFunction(link, idx)
            }
        }
    },
    async mounted(){
        await this.getBrowseData();
        Swiper.use([Navigation]);
        this.swiper = new Swiper(".browse-swiper", {
            direction: "horizontal",
            breakpoints: {
                769: {
                    slidesPerGroup: 1,
                    slidesPerView: 3,
                    slidesPerColumn: 1,
                    spaceBetween: 16,
                }
            },
            slidesPerView: 1.2,
            slidesPerColumn: 2,
            slidesPerColumnFill: 'row',
            spaceBetween: 8,
            modules: [Navigation],
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            }
        });
    }
}
